export const baseChartStyle = {
  grid: {
    horzLines: {
      visible: false
    },
    vertLines: {
      visible: false
    }
  },
  timeScale: {
    visible: false,
    barSpacing: 0
  },
  rightPriceScale: {
    visible: false
  },
  crosshair: {
    vertLine: {
      visible: false
    },
    horzLine: {
      visible: false
    }
  },
  handleScroll: false,
  handleScale: false,
  layout: {
    background: { color: 'transparent' }
  }
};

export const sparkLineStyle = {
  crosshairMarkerVisible: false
};

export enum TradingMovement {
  UP = 'up',
  EQUAL = 'up',
  DOWN = 'down'
}
